<template>
    <div class="app">
        <ModeForecast />
    </div>
</template>

<script setup lang="ts">
import ModeForecast from './views/SecondaryMenuList/ModelForecast/ModeForecast.vue';

</script>

<style lang="scss"></style>